import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { routes } from './routes'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueNumber from 'vue-number-animation'
import store from '@/store/index'
import Vuelidate from 'vuelidate'
import Vue2Editor from "vue2-editor"
import vSelect from 'vue-select'
import '@mdi/font/css/materialdesignicons.css'
import TextHighlight from 'vue-text-highlight';
import VueClipboard from 'vue-clipboard2'
import VueApexCharts from 'vue-apexcharts'
 
import Papa from 'papaparse';


import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';



import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-theme-material.css";
import "ag-grid-community/styles/ag-theme-balham.css";


Vue.component('AgGridVue', AgGridVue);


Vue.use(VueApexCharts)
Vue.use(VueClipboard)

Vue.component('apexchart', VueApexCharts) 


Vue.prototype.$papa = Papa;
// Vue.use(Buefy, {
//   defaultIconPack: 'fas',
//   defaultContainerElement: '#content',
//   // ...
// })
Vue.component('text-highlight', TextHighlight);

Vue.use(Vue2Editor)
Vue.use(VueRouter)
Vue.use(Buefy)
Vue.use(VueNumber)
Vue.use(Vuelidate)
Vue.component('v-select', vSelect)



// Vue.config.productionTip = false
const router = new VueRouter({
  mode:'history',
  hash: false,
  routes
});



// router.beforeEach((to, from, next) => {
//   console.log(to.path)
//   console.log(from)
//   next()
//
//   if (to.part == '/login'){
//     console.log('enter path login')
//     console.log(from)
//   }
//
//   // next()
// })



new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
